import { Box, Typography } from '@mui/material';
import { useState, useMemo } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import UserPreferencesTab from './tabs/UserPreferencesTab';
import MasterDataTab from './tabs/MasterDataTab';
import SupplierPortMappingTab from './tabs/SupplierPortMappingTab';
import { useRoleCheck } from '../../../shared/auth/authUtils';
import { DataService } from '../../../shared/auth/DataService';

const ADMIN_ROLES = ['LP_Admin', 'DP_Vessel_Journal_Key_User'];

const SettingsPage = () => {
  useRoleCheck('settings');
  const [value, setValue] = useState(0);

  const isAdmin = useMemo(() => {
    const userRoles = DataService.getUserRoles();
    return ADMIN_ROLES.some((role) => userRoles?.includes(role));
  }, []);

  const tabs = useMemo(() => {
    const allTabs = [
      {
        label: 'User Preferences',
        icon: <TuneOutlinedIcon />,
        component: <UserPreferencesTab />,
        adminOnly: false,
      },
      {
        label: 'Supplier Port Mapping',
        icon: <SupervisorAccountOutlinedIcon />,
        component: <SupplierPortMappingTab />,
        adminOnly: true,
      },
      {
        label: 'Master Data',
        icon: <DescriptionOutlinedIcon />,
        component: <MasterDataTab />,
        adminOnly: true,
      },
    ];
    return allTabs.filter((tab) => !tab.adminOnly || isAdmin);
  }, [isAdmin]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', top: 60, p: 5 }} alignItems='center'>
      <Typography variant={'h2'}>Settings</Typography>
      <Tabs value={value} onChange={handleChange} aria-label='settings tabs'>
        {tabs.map((tab, index) => (
          <Tab key={index} icon={tab.icon} label={tab.label} />
        ))}
      </Tabs>
      <Box sx={{ mt: 3 }}>{tabs[value]?.component}</Box>
    </Box>
  );
};

export { SettingsPage };
